/* tslint:disable */

declare var Object: any;
export interface UIPortalClientInterface {
  "id"?: number;
}

export class UIPortalClient implements UIPortalClientInterface {
  "id": number;
  constructor(data?: UIPortalClientInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `UIPortalClient`.
   */
  public static getModelName() {
    return "UIPortalClient";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of UIPortalClient for dynamic purposes.
  **/
  public static factory(data: UIPortalClientInterface): UIPortalClient{
    return new UIPortalClient(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'UIPortalClient',
      plural: 'UIPortalClient',
      path: 'UIPortalClient',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
